// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"8c3a7d04","453":"a0e99075"}[chunkId] + ".chunk.js";
};